module.exports = __webpack_public_path__ + "img/noresults.50246626.png";